module.exports = __webpack_public_path__ + "static/media/manage.fbe431a9.svg";